import { Check } from '@sparkware/app-utils';
import { IServiceFactoryExtended } from '../service-factory-extended.interface';
import { ServiceBase } from '../ServiceBase';
import { IBecauseYouPlayedService } from './because-you-played.service.interface';

const BECAUSE_YOU_PLAYED_LAST_REAL_GAME_LOCAL_STORAGE_KEY = "because_you_played_last_played_real_game";

export class BecauseYouPlayedService extends ServiceBase implements IBecauseYouPlayedService {

  constructor(serviceFactory: IServiceFactoryExtended) {
    super(serviceFactory);

    this.reaction(() => { return { isAuthorized: this.services.user.isAuthorized, lastPlayedRealGame: this.services.runningGame.lastPlayedRealGame } },
      (data) => {
        if (data.isAuthorized) {
          if (data.lastPlayedRealGame) {
            this._setBecauseYouPlayedLastPlayedRealGameLocalStorage(
              this.services.abTestingFeatureDataProvider.isBecauseYouPlayedEnabled ? data.lastPlayedRealGame.gameType : 0
            );
          }

          if (!this.services.abTestingFeatureDataProvider.isBecauseYouPlayedEnabled) {
            // make sure that, if another user is logged in and does not have becauseYouPlayed AB enabled, we reset it
            this._setBecauseYouPlayedLastPlayedRealGameLocalStorage(0);
          }
        }
      }
    );

    this._init();
  }

  get isEnabled(): boolean {
    if (this.services.user.isAuthorized) {
      return this.services.abTestingFeatureDataProvider.isBecauseYouPlayedEnabled;
    } else {
      const gameType = this._getBecauseYouPlayedLastPlayedRealGameLocalStorage();
      return gameType !== 0;
    }
  }

  _init() {
    const gameType = this._getBecauseYouPlayedLastPlayedRealGameLocalStorage();
    if (gameType) {
      this.services.runningGame.setLastPlayedRealGame(gameType);
    }
  }

  private _getBecauseYouPlayedLastPlayedRealGameLocalStorage(): number {
    let result: number = 0;
    try {
      const storedValue = Number(this.services.storage.getItem(BECAUSE_YOU_PLAYED_LAST_REAL_GAME_LOCAL_STORAGE_KEY));
      if (Check.isNumber(storedValue)) {
        result = storedValue;
      }
      return result;
    } catch (err) {
      this.services.logger.error(`Failed to parse ${BECAUSE_YOU_PLAYED_LAST_REAL_GAME_LOCAL_STORAGE_KEY} from local storage! Error details: `, err);
      return result;
    }
  }

  private _setBecauseYouPlayedLastPlayedRealGameLocalStorage(gameType: number) {
    this.services.storage.setItem(BECAUSE_YOU_PLAYED_LAST_REAL_GAME_LOCAL_STORAGE_KEY, gameType);
  }
}
